export enum DocsVerificationTabEnum {
    PERSONAL_DATA = 'PERSONAL_DATA',
    DOCUMENT = 'DOCUMENT',
    BIOMETRICS = 'BIOMETRICS',
    ADDRESS = 'ADDRESS',
}
